(ns motorsaif.web.admin.localization
  (:require [reagent.core :as r]
            [motorsaif.data-utils :as du]
            [goog.string :as gstr :refer [format]]
            [goog.string.format]
            [motorsaif.i18n :refer [tr] :as i18n]
            [re-frame.core :refer [subscribe dispatch]]
            [clojure.string :as str]))



(defn on-change-fn [modify-target k e & [coercion-fn]]
  (let [value (if (.-target e)
                ^js (.-target.value e) e)
        value (if coercion-fn
                (coercion-fn value)
                value)]
    (if (fn? modify-target)
      (if (keyword? k)
        (modify-target #(assoc % k value))
        (modify-target #(assoc-in % k value)))
      (if (keyword? k)
        (swap! modify-target assoc k value)
        (swap! modify-target assoc-in k value)))))

(defn validate-edn-str [s]
  (try
    (do
      (cljs.tools.reader.edn/read-string s)
      true)
    (catch js/Object e
      false)))

(defn map-as-inputs
  [data path on-change-fn existing-data]
  (let [curr-node (get-in data path)
        ?existing-val (get-in existing-data path)
        branches (keys curr-node)
        *shown (r/atom true)]
    (fn []
      (if (map? curr-node)
        [:div.map-node
         {:class (when (not (empty? path)) "translation-block")}
         (when (not (empty? path))
           [:button.btn.parent-key
            {:on-click #(swap! *shown not)}
            (str/capitalize (name (last path)))])
         (into [:div.key-block]
               (when @*shown
                 (sort (map
                        (fn [branch]
                          ^{:key branch}
                          [map-as-inputs data (conj path branch) on-change-fn existing-data]) branches))))]

        [:div.input-with-label
         (condp = (last path)
           :raw
           [:label
            [:span.font-weight-500
             "Raw" (str path)]
            [:br]
            (str curr-node)]
           :content [:label "Content"]
           [:div.key
            (format "%s" (last path))])

         (condp = (last path)
           :raw
           (let [*valid? (r/atom
                          (if (not (empty? ?existing-val))
                            (validate-edn-str (str ?existing-val))
                            nil))]
             [(fn []
                [:textarea
                 (-> {:defaultValue (when ?existing-val
                                      (str ?existing-val))
                      :on-change #(on-change-fn path % (fn [s]
                                                         (if (validate-edn-str s)
                                                           (do
                                                             (reset! *valid? true)
                                                             (cljs.tools.reader.edn/read-string s))
                                                           (do
                                                             (reset! *valid? false)
                                                             s))))
                      :data-path path}
                     (cond-> (empty? ?existing-val)
                       (merge {:style {:border-color "red"}}))
                     (cond-> (= false @*valid?)
                       (merge {:style {:border-color "#ff9900"}}))
                     (cond-> @*valid?
                       (merge {:style {:border-color "#3fb132"}})))])])


           :content-markdown
           [:textarea
            (-> {:defaultValue ?existing-val
                 :rows 8
                 :on-change #(on-change-fn path %)
                 :data-path path}
                (cond-> (empty? ?existing-val)
                  (merge {:style {:border-color "red"}})))]

           :content
           [:textarea
            (-> {:defaultValue (or ?existing-val (str curr-node))
                 :on-change #(on-change-fn path %)
                 :data-path path}
                (cond-> (empty? ?existing-val)
                  (merge {:style {:border-color "red"}})))]

           [:input
            (-> {:type "text"
                 :placeholder curr-node
                 :defaultValue (str ?existing-val)
                 :on-change #(on-change-fn path %)
                 :data-path path}
                (cond-> (empty? ?existing-val)
                  (merge {:style {:border-color "red"}})))]
           )
         [:div.en-translation curr-node]]))))

(defn translation [*translation *locale]
  (let [initial-vals (get @*translation @*locale)
        *field-vals (r/atom (@*locale @*translation))
        on-change-fn (partial on-change-fn *field-vals)
        on-save-fn (fn []
                     (let [data {:translation/lang @*locale
                                 :translation/data (str
                                                    (du/deep-remove-empty-vals @*field-vals))}]
                       (dispatch [:admin/post-translation data])))

        *show-debug? (r/atom true)
        *location-shown? (r/atom true)
        *cars-shown? (r/atom true)

        translation-data (:en @*translation)

        *raw-data-paste (r/atom nil)

        save-raw-data-fn (fn []
                           (let [data {:translation/lang @*locale
                                       :translation/data @*raw-data-paste}]
                             #_(dispatch [:mutate-site-setting {:data [data]}])))]

    (r/create-class
      {:reagent-render
       (fn [*translation *locale]
         [:div.wrap
          [:ul.tabs
           [:li
            {:on-click #(reset! *locale :en)
             :class (when (= @*locale :en) "active")}
            "English"]
           [:li
            {:on-click #(reset! *locale :ar)
             :class (when (= @*locale :ar) "active")}
            "Arabic"]
           [:li
            {:on-click #(reset! *locale :ur)
             :class (when (= @*locale :ur) "active")}
            "Urdu"]]

          [:div.tab-body
           [:h5 "Data Diff"]
           (let [[old new] (clojure.data/diff
                            initial-vals
                            @*field-vals)]
             [:div
              [:h5 "Old"]
              [:pre (str old)]
              [:h5 "New"]
              [:pre (str (du/deep-remove-empty-vals new))]])
           [:button.btn.primary.float-save
            {:on-click on-save-fn}
            "Save"]
           [:br]
           [:br]
           [:h4 "Raw Data"]
           #_[:h5 "Paste"]
           #_[:input
            {:type "text"
             :placeholder "Paste Raw Data"
             :on-change #(reset! *raw-data-paste ^js (.-target.value %))}]
           (when (and @*raw-data-paste (validate-edn-str @*raw-data-paste))
             [:div
              [:br]
              [:button.btn-default.btn.btn.primary
               {:on-click save-raw-data-fn}
               "Save Raw Data"]])

           [:h5 "Current"]
           [:pre
            (str (du/deep-remove-empty-vals @*field-vals))]
           [map-as-inputs translation-data [] on-change-fn (@*locale @*translation)]]])})))

(defn root []
  (r/create-class
    {:component-did-mount #(do
                             nil)
     :reagent-render
     (fn []
       (let [*translation (subscribe [:dict])
             *locale (r/atom :ar)]
         (fn []
           ;; [:h1 "HI"]
           [:div#localization
            [:div.page-header
             [:h1.page-title "Localization"]]
            [:div.page-content.container
             [:h4 "Translations"]
             ^{:key (str @*locale)}
             [translation *translation *locale]]])))}))
